import React from 'react';
import { NavLink, Link } from 'react-router-dom';

import '../../scss/organisms/Sidebar.scss';
import logotipo from '../../images/brand/logotipo-negativo-color-corporativo.svg'

function Sidebar() {
  return (
    <section className="Sidebar">
      <Link to='/'>
        <figure className="Sidebar__logo text-center">
          <img width="200" src={logotipo} alt="T-REXPACE"/>
        </figure>
      </Link>
      <h3>Design System</h3>
      <div className="Sidebar__menu">
        <div>
          <nav className="mb-20">
            <ul>
              <li>
                <NavLink className="Sidebar__link" activeClassName="active" to="/principles">Principios</NavLink>
              </li>
            </ul>
          </nav>
          <nav className="mb-20">
            <h4 className="mb-10">Tokens</h4>
            <ul>
              <li>
                <NavLink className="Sidebar__link" activeClassName="active" to="/colors">Colores</NavLink>
              </li>
              <li>
                <NavLink className="Sidebar__link" activeClassName="active" to="/typography">Tipografías</NavLink>
              </li>
              <li>
                <NavLink className="Sidebar__link" activeClassName="active" to="/spacing">Espaciado</NavLink>
              </li>
              <li>
                <NavLink className="Sidebar__link" activeClassName="active" to="/animations">Animaciones</NavLink>
              </li>
              <li>
                <NavLink className="Sidebar__link" activeClassName="active" to="/iconography">Iconografía</NavLink>
              </li>
            </ul>
          </nav>
          <nav>
            <h4 className="mb-10">Componentes</h4>
            <ul>
              <li>
                <NavLink className="Sidebar__link" activeClassName="active" to="/grid">Grid</NavLink>
              </li>
              <li>
                <NavLink className="Sidebar__link" activeClassName="active" to="/header">Header</NavLink>
              </li>
              <li>
                <NavLink className="Sidebar__link" activeClassName="active" to="/footer">Footer</NavLink>
              </li>
              <li>
                <NavLink className="Sidebar__link" activeClassName="active" to="/buttons">Botones</NavLink>
              </li>
              <li>
                <NavLink className="Sidebar__link" activeClassName="active" to="/forms">Formularios</NavLink>
              </li>
              <li>
                <NavLink className="Sidebar__link" activeClassName="active" to="/asteroid-card">Asteroid Card</NavLink>
              </li>
              <li>
                <NavLink className="Sidebar__link" activeClassName="active" to="/form-birthday">Form Birthday</NavLink>
              </li>
              <li>
                <NavLink className="Sidebar__link" activeClassName="active" to="/hazardous-card">Hazardous Indicator Card</NavLink>
              </li>
              <li>
                <NavLink className="Sidebar__link" activeClassName="active" to="/player-data">Player Data</NavLink>
              </li>
              <li>
                <NavLink className="Sidebar__link" activeClassName="active" to="/row-graph-data">Row Graph Data</NavLink>
              </li>
              <li>
                <NavLink className="Sidebar__link" activeClassName="active" to="/order-dropdown">Order Dropdown</NavLink>
              </li>
              <li>
                <NavLink className="Sidebar__link" activeClassName="active" to="/comparative-container">Comparative Container</NavLink>
              </li>
              <li>
                <NavLink className="Sidebar__link" activeClassName="active" to="/modal-suscribe">Modal Suscribe</NavLink>
              </li>
              <li>
                <NavLink className="Sidebar__link" activeClassName="active" to="/modal-birthday">Modal Birthday</NavLink>
              </li>
            </ul>
          </nav>
        </div>
        <p><small>Para cualquier información contáctanos al correo <a className="Sidebar__link" href="mailto:trexpace298@gmail.com">trexpace298@gmail.com</a></small></p>
      </div>
    </section>
  )
}

export default Sidebar